import { render, staticRenderFns } from "./ClassificationDegreeForm.vue?vue&type=template&id=8736fc38&"
import script from "./ClassificationDegreeForm.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegreeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports